import React from 'react';
import styles from './ScanStatus.module.css';

export default function ScanStatus({ stores, agentStatus, agentData }) {
  return (
    <div className={styles.bar}>
      <span className={styles.label}>Scanning</span>
      {stores.map((s) => {
        const status  = agentStatus[s.id] || 'loading';
        const done    = status === 'done';
        const error   = status === 'error';
        const skipped = status === 'skipped';
        const count   = (agentData[s.id] || []).length;
        return (
          <div key={s.id} className={`${styles.pill} ${skipped ? styles.pillSkipped : ''}`}>
            <span
              className={`${styles.dot} ${done ? styles.dotDone : error ? styles.dotError : skipped ? styles.dotSkipped : styles.dotLoading}`}
              style={{ background: error ? '#ef4444' : skipped ? '#cbd5e1' : s.color }}
            />
            <span style={{ color: error ? '#ef4444' : skipped ? '#94a3b8' : s.color, fontWeight: 500, fontSize: 11 }}>{s.name}</span>
            <span className={styles.count}>
              {done ? `· ${count} found` : error ? '· error' : skipped ? '· skipped' : '…'}
            </span>
          </div>
        );
      })}
    </div>
  );
}
